import { Popover, Radio } from "antd";
import { useState } from "react";

import { getVariantPrice } from "../../../../utils/helpers";
import styles from "../../ProductCard.module.scss";
import { DownOutlined } from "@ant-design/icons";

export const ProductCardVariants = ({
  variants = [],
  selectedVariant = {},
  setSelectedVariant,
}) => {
  const [open, setOpen] = useState(false);

  if (variants.length < 1) {
    return null;
  }

  if (variants.length === 1) {
    const [variant] = variants;
    return (
      <span>
        {variant.value} / {getVariantPrice(variant).toFixed(2)} €
      </span>
    );
  }

  const selectedIndex = variants.findIndex(
    (variant) => variant.value === selectedVariant?.value,
  );

  const onVariantChange = (event) => {
    setSelectedVariant(variants[event.target.value]);
    setOpen(false);
  };

  // the text that opens the variant list
  const ProductVariant = () => (
    <span className={styles.variant_trigger}>
      {variants.length} variants available{" "}
      <DownOutlined style={{ fontSize: 8 }} />
    </span>
  );

  const VariantList = () => (
    <Radio.Group
      className={styles.variant_list}
      value={selectedIndex}
      onChange={onVariantChange}
    >
      {variants.map((variant, index) => (
        <Radio
          key={variant.id ?? variant.value ?? index}
          value={index}
          className={styles.variant_list_item}
        >
          <span className={styles.variant_list_item_value}>
            {variant.value} / {getVariantPrice(variant).toFixed(2)} €
          </span>
          {variant.stock === 0 && (
            <span className={styles.variant_list_item_stock}>Out of Stock</span>
          )}
        </Radio>
      ))}
    </Radio.Group>
  );

  return (
    <Popover
      content={<VariantList />}
      trigger="click"
      placement="bottom"
      open={open}
      onOpenChange={(newOpen) => setOpen(newOpen)}
    >
      <div className={styles.variant_trigger_wrapper}>
        <ProductVariant />
      </div>
    </Popover>
  );
};
